import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M18.33 2.01h3.372l-7.369 8.422 8.67 11.464h-6.789l-5.32-6.953-6.083 6.953H1.438l7.883-9.02L1 2h6.962l4.807 6.353 5.56-6.344Zm-1.184 17.865h1.87L6.95 3.92H4.944l12.202 15.954Z" }, null, -1)
  ])))
}
export default { render: render }